module.exports = __webpack_public_path__ + "img/hr-red-asterisk-18.6b7520f1.png";